<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "forms.collection.title" | translate }}</h1>

    <ul class="list-inline material-form-tabs">
      <li class="list-inline-item">
        <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 1]" routerLinkActive="active">
          {{ "forms.collection.nav.basic" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 2]" routerLinkActive="active">
          {{ "forms.collection.nav.educational" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 3]" routerLinkActive="active">
          {{ "forms.collection.nav.material" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 4]" routerLinkActive="active">
          {{ "forms.collection.nav.preview" | translate }}
        </a>
      </li>
    </ul>

    @if (collection) {
      @switch (tabId) {
        @case (1) {
          <app-collection-basic-details-tab
            [collection]="collection"
            [collectionId]="collectionId"
            [tabId]="1"
          (abort)="openConfirmAbortModal(confirmAbort)"></app-collection-basic-details-tab>
        }
        @case (2) {
          <app-collection-educational-details-tab
            [collection]="collection"
            [collectionId]="collectionId"
            [tabId]="2"
          (abort)="openConfirmAbortModal(confirmAbort)"></app-collection-educational-details-tab>
        }
        @case (3) {
          <app-collection-materials-tab
            [collection]="collection"
            [collectionId]="collectionId"
            [tabId]="3"
          (abort)="openConfirmAbortModal(confirmAbort)"></app-collection-materials-tab>
        }
        @case (4) {
          <app-collection-preview-tab
            [collection]="collection"
            [collectionId]="collectionId"
            [tabId]="4"
          (abort)="openConfirmAbortModal(confirmAbort)"></app-collection-preview-tab>
        }
      }
    }
  </div>
</div>

<ng-template #confirmAbort>
  <div class="modal-body text-center">
    <p>{{ "forms.collection.abort.text" | translate }}</p>

    <button type="button" class="btn btn-blue" (click)="abort()">
      {{ "forms.collection.abort.confirm" | translate }}
    </button>

    <button type="button" class="btn btn-outline-blue" (click)="confirmAbortModalRef.hide()">
      {{ "forms.collection.abort.cancel" | translate }}
    </button>
  </div>
</ng-template>
